import { useTranslation } from 'react-i18next';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useDeleteClientInsurance } from 'api/clients/use-delete-client-insurance';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import type { IDeleteClientInsuranceProps } from './types';

const DeleteClientInsuranceComponent = (props: IDeleteClientInsuranceProps) => {
  const { clientId, insuranceId } = props;
  const { t } = useTranslation();
  const { mutateAsync: deleteInsurance, isLoading: isDeleting } = useDeleteClientInsurance(clientId, insuranceId);

  return (
    <Popconfirm
      title={t('common:delete_confirm_text')}
      okText={t('common:delete')}
      cancelText={t('common:cancel')}
      okButtonProps={{ danger: true }}
      onConfirm={async () => {
        await deleteInsurance();
      }}>
      <Button icon={<DeleteOutlined />} loading={isDeleting} danger />
    </Popconfirm>
  );
};

export const DeleteClientInsurance = withRoleGuard<IDeleteClientInsuranceProps>(DeleteClientInsuranceComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
]);
